import React, { useEffect, useRef } from "react";

export const TP_BUSINESS_UNIT_ID = "6ad989574093d1c8467a2a4e";
const SCRIPT_SRC = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

export function loadTrustpilotScript() {
  if (window.Trustpilot) return Promise.resolve();
  const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
  if (existing) return new Promise((res) => existing.addEventListener("load", res, { once: true }));
  return new Promise((res) => {
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = res;
    document.head.appendChild(s);
  });
}

// Official Trustpilot "Review Collector" button (falls back to a plain link if the script is blocked).
export default function TrustpilotCollector({ id, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    loadTrustpilotScript().then(() => ref.current && window.Trustpilot?.loadFromElement(ref.current, true));
  }, []);

  return (
    <div className={className} data-testid={id}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id={TP_BUSINESS_UNIT_ID}
        data-style-height="52px"
        data-style-width="100%"
      >
        <a href="https://www.trustpilot.com/review/shadowspeakjournal.com" target="_blank" rel="noopener noreferrer"
          className="font-sans text-xs uppercase tracking-[0.22em] text-terracotta hover:text-bone-100">
          Review us on Trustpilot
        </a>
      </div>
    </div>
  );
}
